import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { ProgrammeJSON, ProgrammeModel } from '@/models/programme.model'

export interface ProgrammesStoreState {
  programmes: ProgrammeModel[]
  lastFetchedAt: number | null
  setProgrammes: (programmes: ProgrammeModel[]) => void
  clearProgrammes: () => void
}

export const useProgrammesStore = create<ProgrammesStoreState>()(
  persist(
    (set) => ({
      programmes: [],
      lastFetchedAt: null,
      setProgrammes: (programmes) =>
        set({
          programmes,
          lastFetchedAt: Date.now(),
        }),
      clearProgrammes: () =>
        set({
          programmes: [],
          lastFetchedAt: null,
        }),
    }),
    {
      name: 'kbs-programmes-store',
      version: 1,
      storage:
        typeof window !== 'undefined'
          ? createJSONStorage(() => localStorage)
          : undefined,
      merge: (persistedState, currentState) => {
        if (!persistedState || typeof persistedState !== 'object') {
          return currentState
        }

        const typedState = persistedState as Partial<ProgrammesStoreState>
        const rawProgrammes = Array.isArray(typedState.programmes)
          ? (typedState.programmes as Array<ProgrammeModel | ProgrammeJSON | null>)
          : []

        const programmes = rawProgrammes
          .map((programme) => {
            if (!programme) {
              return null
            }

            return programme instanceof ProgrammeModel
              ? programme
              : ProgrammeModel.fromJSON(programme as ProgrammeJSON)
          })
          .filter((programme): programme is ProgrammeModel => Boolean(programme))

        return {
          ...currentState,
          programmes,
          lastFetchedAt: typedState.lastFetchedAt ?? currentState.lastFetchedAt,
        }
      },
    },
  ),
)
